import React, { Component } from "react";
import shortfetch from "../../components/data/fetch";
import LoadingBar from "../../components/data/loading";

class CheckDuplicates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      data_array: {},
      isLoading: true,
      select_items_list: {},
    };
  }

  componentDidMount() {
    this.fetch_data(1);
  }

  async fetch_data(id) {
    let post_json = {
      id: id,
      type: "check_duplicates",
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    console.log("fetched_data", data.data_array);

    this.setState({
      data_array: data.data_array,
      isLoading: false,
      select_items_list: data,
    });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingBar />;
    }

    return (
      <div>
        {this.state.data_array.map((item) => (
          <div>{item.ModelID}</div>
        ))}
      </div>
    );
  }
}

export default CheckDuplicates;
